import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Scenarios from "./pages/scenarios";
import Scenario from "./pages/scenario-table";
import Users from "./pages/users";
import User from "./pages/user";
import AboutUs from "./pages/about-us";
import Partners from "./pages/partners";
import Sidebar from "./components/common/sidebar";
import Partner from "./pages/partner";
import Classroom from "./pages/classroom";
import Classrooms from "./pages/classrooms";
import Tasks from "./pages/tasks";
import Task from "./pages/task";
import Messages from "./pages/messages";
import Login from "./pages/login";
import { useEffect, useState } from "react";
import Guides from "./pages/guides";

function App() {
  const [hasAuthUser, setHasAuthUser] = useState({});

  useEffect(() => {
    setHasAuthUser(localStorage.getItem("user"));
    const user = localStorage.getItem("user");
    // if (!user && window.location.pathname !== "/login") {
    //   window.location.href = "/login";
    // }
  }, []);

  return (
    <>
      {hasAuthUser && <Sidebar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/scenarios" element={<Scenarios />} />
        <Route path="/scenarios/:id" element={<Scenario />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/:id" element={<User />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/partners/:id" element={<Partner />} />
        <Route path="/classrooms" element={<Classrooms />} />
        <Route path="/classrooms/:id" element={<Classroom />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/tasks/:id" element={<Task />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/login" element={<Login />} />
        <Route path="/guides" element={<Guides />} />
      </Routes>
    </>
  );
}

export default App;
